import { SiteApiPath, useCSKH, useHallApi } from '@99fun-agent/hooks'
import { defineStore } from 'pinia'
const CUSTOMER_SERVICE_CONFIG = 'customer_service'
export const useSiteStore = defineStore('siteStore', () => {
  const { get } = useHallApi()
  const getConfigs = async () => {
    const reqData = {}
    const r = await get<IConfigReply>(SiteApiPath.Configs, reqData)
    let retryTime = 5 * 60 * 1000
    if (r.isSuccess && r.hasData && r.data?.list) {
      const cskhConfig: Record<string, string> = {}
      r.data.list.forEach((item) => {
        if (!item.name || !item.value) return
        if (item.dictType === CUSTOMER_SERVICE_CONFIG) {
          cskhConfig[item.name] = item.value
        }
      })
      useCSKH().install(cskhConfig)
    } else {
      retryTime = 10 * 1000
    }

    setTimeout(() => {
      getConfigs()
    }, retryTime)
  }
  const reset = () => {}
  return { reset, getConfigs }
})

export interface IConfigReply {
  list: IDicData[]
}

export interface IDicData {
  name: string
  value: string
  channel: string
  dictType: string
}
